import React, { useEffect } from 'react';
import Dashboard from './components/Dashboard';
import { SITE_TITLE } from '../shared/constants';
import ThemeToggle from '../shared/components/ThemeToggle';

export default function HubPage() {
  useEffect(() => {
    document.title = SITE_TITLE;
  }, []);

  return (
    <div className="hub-page">
      <p className="hub-text">EM DESENVOLVIMENTO</p>
      <div className="hub-container">
        
        <header className="hub-header">
          <div className="hub-theme"><ThemeToggle /></div>
          <h1 className="hub-title">MED 41</h1>
          <p className="hub-subtitle">Ferramentas da turma</p>
        </header>

        <Dashboard />
        
      </div>
    </div>
  );
}
